import { ApiError } from '../api/client';

const CREDENTIAL_ERROR_MESSAGE = '账号或密码错误，请检查账号是否完整';
const CREDENTIAL_ERROR_CODES = new Set([
  'unauthorized',
  'account_unknown',
  'invalid_credentials',
]);

export const getLoginErrorMessage = (error: unknown, fallback: string): string => {
  if (!(error instanceof ApiError)) {
    return fallback;
  }

  if (error.status === 401 || CREDENTIAL_ERROR_CODES.has(String(error.code))) {
    return CREDENTIAL_ERROR_MESSAGE;
  }

  if (error.code === 'network') {
    return error.message;
  }

  return fallback;
};
